<template>
  <v-dialog persistent v-model="dialogVisible" max-width="350px">
    <template #activator="{ attrs, on }">
      <a style="text-decoration: underline;" v-if="isUpdate" v-on="on">{{ pro_user.name }}</a>
      <v-icon v-else color="primary" v-bind="attrs" v-on="on">
        mdi-plus-circle
      </v-icon>
    </template>

    <v-card>
      <v-card-title style="background-color: #004056" class="white--text">
        <span v-if="isUpdate">Update User</span>
        <span v-else>Create User</span>
      </v-card-title>

      <v-divider />

      <v-form ref="form" @submit.prevent="onSubmit">
        <v-card-text>
          <v-text-field
            dense outlined validate_on_blur
            v-model="name" label="Name"
            :rules=[required]
          />
          
          <v-select
            dense outlined validate_on_blur
            v-model="contact_method"
            label="Contact Type"
            placeholder="Choose contact type"
            :items="['email', 'phone']"
            :disabled="isUpdate"
            :rules="[required]"
            @change="contact=''"
          />

          <v-text-field
            dense outlined validate_on_blur hide-details="auto"
            v-if="contact_method === 'email'"
            v-model="contact"
            label="Contact Email"
            :disabled="isUpdate"
            :rules="[valid_email]"
          />

          <v-text-field
            v-else
            dense outlined validate_on_blur hide-details="auto"
            v-model="contact"
            label="Contact Phone"
            :disabled="isUpdate"
            v-mask="'(###) ###-####'"
            :rules="[valid_us_phone]"
          />
        </v-card-text>

        <v-divider />


        <v-card-actions class="justify-center py-3">
          <v-btn @click="close">Cancel</v-btn>
          <v-btn type="submit" color="primary">
            {{ isUpdate ? 'Save' : 'Create' }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <ErrorOverlay
      title="Error" v-model="error_dialog"
      :loading="loading" :message="error_message"
    />
  </v-dialog>
</template>      
 
<script>
import ErrorOverlay from '@/components/pages/ErrorOverlay';
import { mapActions } from "vuex"
import validations from '@/lib/validations'


export default {
  name: "ProUserDialog",

  props: ["pro_user"],

  components: { ErrorOverlay },

data: () => ({
    dialogVisible: false,

    pro_user_id: -1,
    contact_method: 'phone',
    contact: '',
    name: '',

    // error handling
    loading: false,
    error_dialog: false,
    error_message: '',
  }),

  computed: {
    isUpdate() { 
      return !!this.pro_user?.pro_user_id
      }
  },

  watch: {
    dialogVisible(visible) {
      if (visible) {
        if (this.isUpdate) {
          this.pro_user_id = this.pro_user.pro_user_id
          this.name = this.pro_user.name
          this.contact_method = this.pro_user.contact_method
          this.contact = this.pro_user.contact
        } else {
          this.pro_user_id = -1
          this.name = ''
          this.contact_method = 'phone'
          this.contact =''
          // if (this.$refs.form)
          //   this.$refs.form.resetValidation()
        }
      }
    },
  },

  methods: {
    ...mapActions("pro_users", ["createUser", "updateUser"]),
    ...validations,

    close() {
      this.dialogVisible = false;
    },

    async onSubmit() {
      if (this.$refs.form.validate()) {
        if (this.isUpdate)
          return this.save()
        else
          return this.create()
      }
    },

    async create() {
      let payload = {
        name: this.name,
        contact_method: this.contact_method,
        contact: this.contact,
      };

      this.loading = true;
      const result = await this.createUser(payload);
      this.loading = false;

      if (result.ok) {
        this.close();
      } else {
        this.error_dialog = true;
        this.error_message = result.error;
      }
    },

    async save() {
      let payload = {
        pro_user_id: this.pro_user_id,
        name: this.name,
      };

      this.loading = true;
      const result = await this.updateUser(payload);
      this.loading = false;

      if (result.ok) {
        this.close();
      } else {
        this.error_dialog = true;
        this.error_message = result.error;
      }
    },
  },
};
</script>